"use client";

import { PropsWithChildren, ReactNode } from "react";

export const StagingOnly = ({
  children,
  fallback,
}: PropsWithChildren<{ fallback?: ReactNode }>) => {
  const isStaging = process.env.NEXT_PUBLIC_ENV === "staging";
  if (!isStaging) {
    return fallback || null;
  }
  return children;
};
